import { useCallback } from "react";
import { DragEndEvent } from "@dnd-kit/core";
import { arrayMove } from "@dnd-kit/sortable";

interface UseSortableDragEventHandlers {
    handleDragEnd: (event: DragEndEvent) => void;
}

export const useSortableDragEventHandlers = (
    items: { id?: any }[],
    onSortChange: (any) => void,
    sortProperty: string
): UseSortableDragEventHandlers => {
    const handleDragEnd = useCallback(
        (event: DragEndEvent) => {
            const { active, over } = event;

            if (active.id !== over?.id) {
                const oldIndex = items.findIndex(
                    (item) => item.id === active.id
                );
                const newIndex = items.findIndex(
                    (item) => item.id === over?.id
                );

                const newlySortedItems = arrayMove(items, oldIndex, newIndex);
                const itemsToUpdate = newlySortedItems.map((item, index) => {
                    // TODO: Better way to do this?
                    // Needed because classes don't work well with Object spread syntax
                    const itemAsJs = JSON.parse(JSON.stringify(item));
                    return { ...itemAsJs, [sortProperty]: index };
                });
                onSortChange(itemsToUpdate);
            }
        },
        [items, onSortChange, sortProperty]
    );

    return {
        handleDragEnd: handleDragEnd,
    };
};
